import styled from "styled-components";
export const Paragraph = styled.p `
  margin: 16px 0 0;
`;
